var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useUser } from "@atlassiansox/microscopekit";
import { userType } from "@atlassiansox/analytics-web-client";
import { analyticsClient } from "../analytics";
import { useServiceId } from "../hooks";
export var useAnalytics = function () {
    var _a;
    var user = useUser();
    var serviceId = useServiceId();
    analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, (_a = user === null || user === void 0 ? void 0 : user.username) !== null && _a !== void 0 ? _a : "");
    return {
        sendUIEvent: function (payload) {
            return analyticsClient.sendUIEvent(__assign(__assign({}, payload), { containerType: "service", containerId: serviceId }));
        },
        sendScreenEvent: function (payload) {
            return analyticsClient.sendScreenEvent(__assign(__assign({}, payload), { containers: {
                    service: {
                        id: serviceId,
                        type: "service"
                    }
                } }));
        },
        sendTrackEvent: function (payload) {
            return analyticsClient.sendTrackEvent(__assign(__assign({}, payload), { containerType: "service", containerId: serviceId }));
        }
    };
};
